import DrEventUpload from './DrEventUpload';

export default DrEventUpload;
